import axios from 'axios';
import qs from 'qs';
import constants from '../constants';
const LICHESS_BASE_URL = constants.LICHESS_BASE_URL;

export const getLichessUser = async () => {
    const lichesstoken = localStorage.getItem('LichessIdToken');
    try {
        const response = await axios.get(`${LICHESS_BASE_URL}/api/account`, {
        headers: {
            'Authorization': lichesstoken
        }
        });
        return response.data;
    } catch (error) {
        console.error('Error getting lichess user:', error);

        throw error;
    }
};

export const startGameWithAI = async (level, clockLimit, clockIncrement) => {
  const lichesstoken = localStorage.getItem('LichessIdToken');
  let data = qs.stringify({
    'level': level,
    'clock.limit': clockLimit,
    'clock.increment': clockIncrement,
    'variant': 'standard' 
  });
  
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${LICHESS_BASE_URL}/api/challenge/ai`,
    headers: { 
      'Content-Type': 'application/x-www-form-urlencoded', 
      'Authorization': lichesstoken
    },
    data : data
  };
  
  const response = await axios.request(config);
  return response.data;
}

export const challengeAPlayer = async (username, clockLimit, clockIncrement) => {
  const lichesstoken = localStorage.getItem('LichessIdToken');
  let data = qs.stringify({
    'clock.limit': clockLimit,
    'clock.increment': clockIncrement,
    'variant': 'standard' 
  });
  
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${LICHESS_BASE_URL}/api/challenge/${username}`,
    headers: { 
      'Content-Type': 'application/x-www-form-urlencoded', 
      'Authorization': lichesstoken
    },
    data : data
  };
  
  const response = await axios.request(config);
  return response.data;
}

export const createASeek = async (clockLimit, clockIncrement) => {
  const lichesstoken = localStorage.getItem('LichessIdToken');
  let data = qs.stringify({
    'time': clockLimit,
    'increment': clockIncrement,
    'variant': 'standard' 
  });
  
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${LICHESS_BASE_URL}/api/board/seek`,
    headers: { 
      'Content-Type': 'application/x-www-form-urlencoded', 
      'Authorization': lichesstoken
    },
    data : data
  };
  
  const response = await axios.request(config);
  return response.data;
}

export const playMove = async (gameId, move) => {
  const lichesstoken = localStorage.getItem('LichessIdToken');
  let config = {
    method: 'post',
    url: `${LICHESS_BASE_URL}/api/board/game/${gameId}/move/${move}`,
    headers: { 
      'Authorization': lichesstoken
    }
  };
  
  const response = await axios.request(config);
  return response.data;
}

export const resignGame = async (gameId) => {
  const lichesstoken = localStorage.getItem('LichessIdToken');
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${LICHESS_BASE_URL}/api/board/game/${gameId}/resign`,
    headers: { 
      'Authorization': lichesstoken
    },
  };
  
  const response = await axios.request(config);
  return response.data;
}

export const offerDraw = async (gameId) => {
  const lichesstoken = localStorage.getItem('LichessIdToken');
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${LICHESS_BASE_URL}/api/board/game/${gameId}/draw/yes`,
    headers: { 
      'Authorization': lichesstoken
    },
  };
  
  const response = await axios.request(config);
  return response.data;
}

export const acceptDraw = async (gameId) => {
  const lichesstoken = localStorage.getItem('LichessIdToken');
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${LICHESS_BASE_URL}/api/board/game/${gameId}/draw/yes`,
    headers: { 
      'Authorization': lichesstoken
    },
  };
  
  const response = await axios.request(config);
  return response.data;
}

export const declineDraw = async (gameId) => {
  const lichesstoken = localStorage.getItem('LichessIdToken');
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${LICHESS_BASE_URL}/api/board/game/${gameId}/draw/no`,
    headers: { 
      'Authorization': lichesstoken
    },
  };
  
  const response = await axios.request(config);
  return response.data;
}
